export const INPUT_TEST_ID = 'INPUT_TEST_ID_';
export const HEADER_LOGOUT_BUTTON = 'HEADER_LOGOUT_BUTTON';
export const TEST_SIGNUP = 'TEST_SIGNUP_';
export const TEST_BUTTON_SIGNUP = 'TEST_BUTTON_SIGNUP';
export const TEST_BUTTON_LOGIN = 'TEST_BUTTON_LOGIN';
export const TEST_BUTTON_RESET_PASSWORD = 'TEST_BUTTON_RESET_PASSWORD';
export const TEST_START_SEARCH_ENTITY = 'TEST_START_SEARCH_ENTITY';
